import React from "react";
import Header from "../components/common/Header";
import PlayWithFriends from "../components/PlayWithFriends";

const PlayWithFriendsPage = () => {
  return (
    <div className="content-card">
      <PlayWithFriends />
    </div>
  );
};

export default PlayWithFriendsPage;
